import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var HeartHand = function HeartHand(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M6 20.0872h2.6103c.3403 0 .6786.0405 1.0085.1215l2.7581.6702a4.27 4.27 0 0 0 1.8266.0425l3.0495-.5933c.8055-.1569 1.5466-.5426 2.1273-1.1076l2.1576-2.0988c.6161-.5983.6161-1.5693 0-2.1686-.5547-.5396-1.4332-.6004-2.0608-.1428l-2.5145 1.8346c-.3601.2632-.7983.4049-1.2489.4049h-2.4282 1.5456c.8711 0 1.5768-.6865 1.5768-1.5339v-.3067c0-.7037-.4923-1.3172-1.1938-1.4873l-2.3855-.5801A5.03 5.03 0 0 0 11.6431 13c-.9648 0-2.7112.7988-2.7112.7988L6 15.0249M2 14.6v5.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C2.76 22 3.04 22 3.6 22h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C6 21.2401 6 20.9601 6 20.4v-5.8c0-.56 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C5.24 13 4.96 13 4.4 13h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 13.7599 2 14.04 2 14.6M17.1914 3.5923c-.5968-1.2489-1.9728-1.9105-3.311-1.272-1.3381.6387-1.9082 2.1531-1.3479 3.4825.3462.8217 1.3382 2.4172 2.0456 3.5163.2613.406.392.609.5829.7278.1637.1019.3687.1568.5614.1505.2247-.0075.4394-.118.8687-.339 1.1621-.598 2.819-1.4838 3.5297-2.0223 1.1499-.8712 1.4348-2.4725.5739-3.6898-.861-1.2174-2.362-1.3372-3.5033-.554"
    })
  }));
};
export default HeartHand;